import React, { useEffect, useState } from "react"

import "./SinglePost.css"
import _ from "lodash"
import {
  collection,
  getDocs,
  query,
  where,
  setDoc,
  doc,
  getDoc,
} from "firebase/firestore"
import { db, storage } from "../../Firebase/Firebase-config"
import {
  ref,
  listAll,
  getDownloadURL,
  uploadBytes,
  storageRef,
} from "firebase/storage"
import moment from "moment/moment"
import loading from "../../asserts/skeltonLoading.gif"
import { useParams } from "react-router-dom"

const SinglePost = () => {
  let { id } = useParams()
  const [blog, setBlog] = useState([])
  const imageListRef = ref(storage, "blog-images/")

  async function addImages() {
    listAll(imageListRef).then((res) => {
      res.items.forEach((item) => {
        getDownloadURL(item).then((url) => {
          // const index = allBlogs.map((blog) =>
          //   _.isEqual(blog.thumbnail, item.name)
          // )
          // for (let i = 0; i < blog.length; i++) {
          const find = _.isEqual(blog[0].thumbnail, item.name)
          if (find) {
            setBlog((prevAllBlogs) =>
              prevAllBlogs.map((blog) => ({ ...blog, url: url, id: id }))
            )
            console.log(url)
          } else {
            setBlog((prevAllBlogs) =>
              prevAllBlogs.map((blog) => ({ ...blog, url: "", id: id }))
            )
          }
          // }
        })
      })
    })

    console.log(blog)
  }

  const getBlog = async () => {
    const docRef = doc(db, "blogs", id)
    const docData = await getDoc(docRef)
    setBlog([docData.data()])
    // console.log([docData.data()])
    addImages()
  }

  useEffect(() => {
    getBlog()
    getBlog()
    console.log(blog)
  }, [blog.length])

  return (
    <div className="single-post-main-box">
      {blog &&
        blog.map((items) => {
          return (
            <div className="single-post-container" key={items.id}>
              <div className="blog-title">{items.tittle}</div>
              <div className="blog-data-cont">
                <div className="blog-img">
                  <img src={items.url ? items.url : loading} alt="blog-image" />
                </div>
                <div className="blog-desc">{items.description}</div>
              </div>
            </div>
          )
        })}
    </div>
  )
}

export default SinglePost
